import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { selectDeckPile } from '../ActiveGame/selectors';
import CardFace from '../Card/CardFace';
import { Slot } from '../Card/styled';
import { PlainButton } from '../Controls';
import { DECK } from '../ActiveGame/contextMenuTypes';
import { setContextMenu } from '../ActiveGame/actions';

const Deck = ({ userId }) => {
  const dispatch = useDispatch();
  const deckPile = useSelector((state) => selectDeckPile(state, { userId }));

  if (!deckPile || !deckPile.get('count')) {
    return <Slot aria-label="Empty deck" />;
  }

  return (
    <PlainButton onClick={() => dispatch(setContextMenu(DECK, userId))} aria-label={`Deck, ${deckPile.get('count')} cards`}>
      <CardFace count={deckPile.get('count')} />
    </PlainButton>
  );
};

Deck.propTypes = {
  userId: PropTypes.number.isRequired,
};

export default Deck;
